<template>
  <div class="station-sty">
    <div class="station-list">
      <div :class="'station-'+ (index+1)" v-for="(item,index) in dataList" :key="index">
        <div @click="checkSeat(item)" v-if="item.useFlag=='1'">{{item.seatNo}}</div>
        <div @click="checkSeat(item)" class="img0" v-if="item.useFlag=='0'">
          <img src="./img/icon.png" alt />
        </div>
      </div>
    </div>
    <div class="h-line"></div>
    <div class="v-line"></div>
    <div class="is-check">
      <div class="check-div">
        <img class="img-0" src="./img/icon0.png" alt />
        <span>可选</span>
      </div>
      <div class="check-div check-div2">
        <img class="img-1" src="./img/icon.png" alt />
        <span>已选</span>
      </div>
    </div>
    <div class="but" @click.prevent="confirm"></div>
  </div>
</template>

<script>
import URL from "@/api/kingWaiter";
export default {
  // props:[show],
  data() {
    return {
      dataList: [],
      hasChooseSeatId: [],//获取后台数据返回的已选中的数据id
      chooseObj: {}//获取当前选中的对象
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let data = {
        startDate: null
      }
      this.$fetchGet(URL.getSeat.url, data).then(res => {
        if (res.data.code == 20000) {
          this.dataList = res.data.data
          //获取选中数据的id集合  useFlag  1-未选中；0-选中
          this.hasChooseSeatId = this.dataList.map(x => {
            if (x.useFlag == 0) {
              return x.id
            }
          })
        }
      })
    },
    //坐位选中  useFlag  1-可用；0-不可用
    checkSeat(item) {
      //当选中的数据在系统已选中的数据中时候
      if (this.hasChooseSeatId.includes(item.id)) {
        //提示系统中已经有人选中此坐位 
        console.log('提示系统中已经有人选中此坐位');
        return
      }
      //当选中的数据再次点击当前选中的数据的时候
      if ((this.chooseObj && this.chooseObj.id) == item.id) {
        //已经选中此坐位
        console.log('已经选中此坐位');
        return
      } else {//点击的数据未选中的时候
        //去除之前选中的值
        this.dataList.map(x => {
          //将上一个选中的座位改为未选中
          if (x.id == (this.chooseObj && this.chooseObj.id)) {
            x.useFlag = 1
          }
        })
        //将当前座位改成选中状态
        item.useFlag = 0
        //做当前选中值的留痕  以方便选中下一个选项的时候 去清除当前选中的状态值
        this.chooseObj = JSON.parse(JSON.stringify(item))
      }
    },
    confirm() {
      console.log(this.chooseObj);
      if (this.chooseObj && this.chooseObj.id) {
        this.$emit('getSeatNum', this.chooseObj)
      } else {
        //提示请选择坐位
        console.log('提示请选择坐位');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.station-sty {
  position: relative;
  width: 375px;
  height: 100vh;
  background: url("./img/div-bg.png") no-repeat 100%;
  background-size: 100% 100%;
  overflow: scroll;
}
.station-list {
  div {
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 9px;
    background: linear-gradient(
      180deg,
      rgba(235, 244, 250, 0.7) 0%,
      rgba(242, 248, 252, 0.49) 47%,
      rgba(255, 255, 255, 0.1) 100%
    );
    opacity: 0.91;
    text-align: center;
  }
  .img0 {
    width: 14px;
    height: 14px;
    img {
      width: 100%;
    }
  }
  .station-1 {
    position: absolute;
    left: 115px;
    top: 392px;
  }
  .station-2 {
    position: absolute;
    left: 143px;
    top: 392px;
  }
  .station-3 {
    position: absolute;
    left: 172px;
    top: 392px;
  }
  .station-4 {
    position: absolute;
    left: 200px;
    top: 392px;
  }
  .station-5 {
    position: absolute;
    left: 230px;
    top: 392px;
  }
  .station-6 {
    position: absolute;
    left: 258px;
    top: 392px;
  }
  .station-7 {
    position: absolute;
    left: 286px;
    top: 392px;
  }
  .station-8 {
    position: absolute;
    left: 315px;
    top: 392px;
  }
  .station-9 {
    position: absolute;
    left: 343px;
    top: 392px;
  }
  .station-10 {
    position: absolute;
    left: 343px;
    top: 363px;
  }
  .station-11 {
    position: absolute;
    left: 315px;
    top: 363px;
  }
  .station-12 {
    position: absolute;
    left: 286px;
    top: 363px;
  }
  .station-13 {
    position: absolute;
    left: 258px;
    top: 363px;
  }
  .station-14 {
    position: absolute;
    left: 230px;
    top: 363px;
  }
  .station-15 {
    position: absolute;
    left: 200px;
    top: 363px;
  }
  .station-16 {
    position: absolute;
    left: 172px;
    top: 363px;
  }
  .station-17 {
    position: absolute;
    left: 143px;
    top: 363px;
  }
  .station-18 {
    position: absolute;
    left: 115px;
    top: 363px;
  }
  .station-19 {
    position: absolute;
    left: 115px;
    top: 337px;
  }
  .station-20 {
    position: absolute;
    left: 143px;
    top: 337px;
  }
  .station-21 {
    position: absolute;
    left: 172px;
    top: 337px;
  }
  .station-22 {
    position: absolute;
    left: 200px;
    top: 337px;
  }
  .station-23 {
    position: absolute;
    left: 230px;
    top: 337px;
  }
  .station-24 {
    position: absolute;
    left: 258px;
    top: 337px;
  }
  .station-25 {
    position: absolute;
    left: 286px;
    top: 337px;
  }
  .station-26 {
    position: absolute;
    left: 315px;
    top: 337px;
  }
  .station-27 {
    position: absolute;
    left: 343px;
    top: 337px;
  }
  .station-28 {
    position: absolute;
    left: 343px;
    top: 309px;
  }
  .station-29 {
    position: absolute;
    left: 315px;
    top: 309px;
  }
  .station-30 {
    position: absolute;
    left: 286px;
    top: 309px;
  }
  .station-31 {
    position: absolute;
    left: 258px;
    top: 309px;
  }
  .station-32 {
    position: absolute;
    left: 230px;
    top: 309px;
  }
  .station-33 {
    position: absolute;
    left: 200px;
    top: 309px;
  }
  .station-34 {
    position: absolute;
    left: 171px;
    top: 309px;
  }
  .station-35 {
    position: absolute;
    left: 143px;
    top: 309px;
  }
  .station-36 {
    position: absolute;
    left: 115px;
    top: 309px;
  }
  .station-37 {
    position: absolute;
    left: 115px;
    top: 281px;
  }
  .station-38 {
    position: absolute;
    left: 143px;
    top: 281px;
  }
  .station-39 {
    position: absolute;
    left: 171px;
    top: 281px;
  }
  .station-40 {
    position: absolute;
    left: 200px;
    top: 281px;
  }
  .station-41 {
    position: absolute;
    left: 286px;
    top: 281px;
  }
  .station-42 {
    position: absolute;
    left: 315px;
    top: 281px;
  }
  .station-43 {
    position: absolute;
    left: 315px;
    top: 253px;
  }
  .station-44 {
    position: absolute;
    left: 286px;
    top: 253px;
  }
  .station-45 {
    position: absolute;
    left: 200px;
    top: 253px;
  }
  .station-46 {
    position: absolute;
    left: 171px;
    top: 253px;
  }
  .station-47 {
    position: absolute;
    left: 143px;
    top: 253px;
  }
  .station-48 {
    position: absolute;
    left: 115px;
    top: 253px;
  }
  .station-49 {
    position: absolute;
    left: 115px;
    top: 222px;
  }
  .station-50 {
    position: absolute;
    left: 143px;
    top: 222px;
  }
  .station-51 {
    position: absolute;
    left: 171px;
    top: 222px;
  }
  .station-52 {
    position: absolute;
    left: 200px;
    top: 222px;
  }
  .station-53 {
    position: absolute;
    left: 230px;
    top: 222px;
  }
  .station-54 {
    position: absolute;
    left: 258px;
    top: 222px;
  }
  .station-55 {
    position: absolute;
    left: 286px;
    top: 222px;
  }
  .station-56 {
    position: absolute;
    left: 315px;
    top: 222px;
  }
  .station-57 {
    position: absolute;
    left: 343px;
    top: 222px;
  }
  .station-58 {
    position: absolute;
    left: 343px;
    top: 195px;
  }
  .station-59 {
    position: absolute;
    left: 315px;
    top: 195px;
  }
  .station-60 {
    position: absolute;
    left: 286px;
    top: 195px;
  }
  .station-61 {
    position: absolute;
    left: 258px;
    top: 195px;
  }
  .station-62 {
    position: absolute;
    left: 230px;
    top: 195px;
  }
  .station-63 {
    position: absolute;
    left: 200px;
    top: 195px;
  }
  .station-64 {
    position: absolute;
    left: 171px;
    top: 195px;
  }
  .station-65 {
    position: absolute;
    left: 143px;
    top: 195px;
  }
  .station-66 {
    position: absolute;
    left: 115px;
    top: 195px;
  }
  .station-67 {
    position: absolute;
    left: 115px;
    top: 165px;
  }
  .station-68 {
    position: absolute;
    left: 143px;
    top: 165px;
  }
  .station-69 {
    position: absolute;
    left: 171px;
    top: 165px;
  }
  .station-70 {
    position: absolute;
    left: 200px;
    top: 165px;
  }
  .station-71 {
    position: absolute;
    left: 230px;
    top: 165px;
  }
  .station-72 {
    position: absolute;
    left: 258px;
    top: 165px;
  }
  .station-73 {
    position: absolute;
    left: 286px;
    top: 165px;
  }
  .station-74 {
    position: absolute;
    left: 315px;
    top: 165px;
  }
  .station-75 {
    position: absolute;
    left: 343px;
    top: 165px;
  }
  .station-76 {
    position: absolute;
    left: 343px;
    top: 139px;
  }
  .station-77 {
    position: absolute;
    left: 315px;
    top: 139px;
  }
  .station-78 {
    position: absolute;
    left: 286px;
    top: 139px;
  }
  .station-79 {
    position: absolute;
    left: 258px;
    top: 139px;
  }
  .station-80 {
    position: absolute;
    left: 230px;
    top: 139px;
  }
  .station-81 {
    position: absolute;
    left: 200px;
    top: 139px;
  }
  .station-82 {
    position: absolute;
    left: 171px;
    top: 139px;
  }
  .station-83 {
    position: absolute;
    left: 143px;
    top: 139px;
  }
  .station-84 {
    position: absolute;
    left: 115px;
    top: 139px;
  }
  .station-85 {
    position: absolute;
    left: 115px;
    top: 111px;
  }
  .station-86 {
    position: absolute;
    left: 143px;
    top: 111px;
  }
  .station-87 {
    position: absolute;
    left: 171px;
    top: 111px;
  }
  .station-88 {
    position: absolute;
    left: 200px;
    top: 111px;
  }
  .station-89 {
    position: absolute;
    left: 286px;
    top: 111px;
  }
  .station-90 {
    position: absolute;
    left: 315px;
    top: 111px;
  }
  .station-91 {
    position: absolute;
    left: 200px;
    top: 81px;
  }
  .station-92 {
    position: absolute;
    left: 171px;
    top: 81px;
  }
  .station-93 {
    position: absolute;
    left: 143px;
    top: 81px;
  }
  .station-94 {
    position: absolute;
    left: 115px;
    top: 81px;
  }
  .station-95 {
    position: absolute;
    left: 115px;
    top: 55px;
  }
  .station-96 {
    position: absolute;
    left: 142px;
    top: 55px;
  }
  .station-97 {
    position: absolute;
    left: 172px;
    top: 55px;
  }
  .station-98 {
    position: absolute;
    left: 200px;
    top: 55px;
  }
  .station-99 {
    position: absolute;
    left: 229px;
    top: 55px;
  }
  .station-100 {
    position: absolute;
    left: 258px;
    top: 55px;
  }
  .station-101 {
    position: absolute;
    left: 258px;
    top: 27px;
  }
  .station-102 {
    position: absolute;
    left: 229px;
    top: 27px;
  }
  .station-103 {
    position: absolute;
    left: 200px;
    top: 27px;
  }
  .station-104 {
    position: absolute;
    left: 172px;
    top: 27px;
  }
  .station-105 {
    position: absolute;
    left: 142px;
    top: 27px;
  }
  .station-106 {
    position: absolute;
    left: 115px;
    top: 27px;
  }
  .station-107 {
    position: absolute;
    left: 71px;
    top: 27px;
  }
  .station-108 {
    position: absolute;
    left: 42px;
    top: 27px;
  }
  .station-109 {
    position: absolute;
    left: 13px;
    top: 27px;
  }
  .station-110 {
    position: absolute;
    left: 13px;
    top: 55px;
  }
  .station-111 {
    position: absolute;
    left: 42px;
    top: 55px;
  }
  .station-112 {
    position: absolute;
    left: 71px;
    top: 55px;
  }
  .station-113 {
    position: absolute;
    left: 71px;
    top: 83px;
  }
  .station-114 {
    position: absolute;
    left: 42px;
    top: 83px;
  }
  .station-115 {
    position: absolute;
    left: 13px;
    top: 83px;
  }
  .station-116 {
    position: absolute;
    left: 13px;
    top: 111px;
  }
  .station-117 {
    position: absolute;
    left: 42px;
    top: 111px;
  }
  .station-118 {
    position: absolute;
    left: 71px;
    top: 111px;
  }
}
.h-line {
  width: 356px;
  height: 10px;
  background: url("./img/H-line.png") no-repeat 100%;
  background-size: 100% 100%;
  position: absolute;
  top: 429px;
  left: 10px;
}

.v-line {
  width: 4px;
  height: 386px;
  background: url("./img/V-line.png") no-repeat 100%;
  background-size: 100% 100%;
  position: absolute;
  top: 24px;
  left: 99px;
}
.is-check {
  width: 356px;
  height: 45px;
  // background: url('./img/bg1.png') no-repeat 100%;
  // background-size: 100% 100%;
  border: 1px solid;
  position: absolute;
  top: 460px;
  left: 10px;
}
.is-check {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .check-div {
    display: flex;

    align-items: center;
    .img-0 {
      width: 16px;
      height: 18px;
    }
    .img-1 {
      width: 14px;
      height: 14px;
    }
    span {
      margin-left: 10px;
      font-size: 11px;
    }
  }
}
.but {
  width: 273px;
  height: 30px;
  background: url("./img/but.png") no-repeat 50%;
  background-size: 100% 100%;
  position: absolute;
  top: 553px;
  left: 52px;
}
</style>